import React from 'react';

import type { HNCoreFrontendWebForside } from '../types/Resources';

import FeedbackModalContainer from '@helsenorge/core-framework/feedbackmodal-container';
import FeedbackPanelContainer from '@helsenorge/core-framework/feedbackpanel-container';
import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';
import { hasSamtykke } from '@helsenorge/framework-utils/samtykke-utils';
import { HNeventSetNoMarginFooter } from '@helsenorge/framework-utils/web-component/events';

import ArticlesContainer from '../articles';
import Projects from '../constants/projects';
import ContainerColumn from '../container-column';
import FastlegePanel from '../fastlege-v2';
import KrisepanelContainer from '../krisepanel-container';
import OtherContainer from '../other-container';
import { useSuspenseResources } from '../resources';
import SavnerDuTjenester from '../savner-du-tjenester-v2';
import SearchBlockContainer from '../search-container-v2';
import { useAppSelector } from '../store/hooks';
import containerstyles from './../containers.module.scss';
import { useGetTilesQuery } from '../store/tilesApi';
import TjenestepanelContainer from '../tjenestepanel-container-v2';
import UserAccessWarning from '../useraccesswarning-v2';

const Forside: React.FunctionComponent = () => {
  const language = useAppSelector(state => selectCurrentLanguage(state.language));
  const resources = useSuspenseResources<HNCoreFrontendWebForside>(Projects.Forside);
  const { data: tilesResponse } = useGetTilesQuery(language);

  React.useEffect(() => {
    document.body.classList.add(containerstyles['blueberry']);
    HNeventSetNoMarginFooter();
  }, []);

  const showFastlegePanel = !!tilesResponse?.fastlegeTextMessage;
  const showSavnerDuTjenester = !!tilesResponse?.missingServiceWarning;
  const showOtherContainer = showFastlegePanel || showSavnerDuTjenester;

  return (
    <>
      <KrisepanelContainer />
      <UserAccessWarning resources={resources} />
      {hasSamtykke() && <TjenestepanelContainer resources={resources} />}

      <ContainerColumn>
        <FeedbackPanelContainer position="after-title" />
        <FeedbackPanelContainer position="after-page-header" />
        <FeedbackPanelContainer position="page-bottom" />
        <FeedbackPanelContainer position="custom" />
      </ContainerColumn>

      {showOtherContainer && (
        <OtherContainer>
          {showSavnerDuTjenester && (
            <div className="container">
              <div className="row">
                <div className="col col-lg-6">
                  <SavnerDuTjenester
                    title={tilesResponse.missingServiceWarning?.title}
                    description={tilesResponse.missingServiceWarning?.description}
                    bodyTexts={tilesResponse.missingServiceWarning?.bodyTexts}
                    buttonText={tilesResponse.missingServiceWarning?.buttonText}
                  />
                </div>
              </div>
            </div>
          )}
          {showFastlegePanel &&
            tilesResponse.fastlegeTextMessage?.title &&
            tilesResponse.fastlegeTextMessage?.description &&
            tilesResponse.fastlegeTextMessage?.link && (
              <div className="container">
                <div className="row">
                  <div className="col">
                    <FastlegePanel
                      title={tilesResponse.fastlegeTextMessage.title}
                      description={tilesResponse.fastlegeTextMessage.description}
                      link={tilesResponse.fastlegeTextMessage.link as unknown as string}
                    />
                  </div>
                </div>
              </div>
            )}
        </OtherContainer>
      )}

      <ArticlesContainer />
      <SearchBlockContainer />

      <FeedbackModalContainer />
    </>
  );
};
export default Forside;
